import { render, staticRenderFns } from "./blackinfo.vue?vue&type=template&id=2dae32c0&scoped=true&"
import script from "./blackinfo.vue?vue&type=script&lang=js&"
export * from "./blackinfo.vue?vue&type=script&lang=js&"
import style0 from "./blackinfo.vue?vue&type=style&index=0&id=2dae32c0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae32c0",
  null
  
)

export default component.exports